export const TEXT = 'TEXT';
